import addToSummaryArr from "./add_to_summaryArr";

export const calcInvestmentSummary=(summaryBuyArr, investType, summaryArr) => {
    let totalCurrentValue = 0;
    let totalInitialValue = 0;
    let totalByInvestTypeArr = [];
    if (summaryBuyArr.buyTransArr.length > 0){
        for (let j=0; j<summaryBuyArr.buyTransArr.length; j++){
            const buyTransItem = summaryBuyArr.buyTransArr[j];
            totalCurrentValue += +buyTransItem.totalCurrentPrice;
            totalInitialValue += +buyTransItem.totalInitialPrice;
            addToSummaryArr("investments", investType, +buyTransItem.totalInitialPrice, 
                +buyTransItem.totalCurrentPrice, summaryArr);
        }
        totalCurrentValue = +totalCurrentValue.toFixed(2);
        totalInitialValue = +totalInitialValue.toFixed(2);
        const totalByInvestTypeObj = {investType: investType, totalCurrentValue: totalCurrentValue, 
            totalInitialValue: totalInitialValue,
        };
        totalByInvestTypeArr.push(totalByInvestTypeObj);
    }
       
    if (totalInitialValue > 0){
        addToSummaryArr("investments", "", totalInitialValue, totalCurrentValue, summaryArr);
    }
    addToSummaryArr("Total Amounts", "", totalInitialValue, totalCurrentValue, summaryArr);
    return totalByInvestTypeArr;
       
}
export default calcInvestmentSummary;
